export default {
  formComponents: {
    section_title: 'form-title',
    singleline: 'form-input',
    multiline: 'form-input',
    email: 'form-input',
    number: 'form-input',
    url: 'form-input',
    checkbox: 'form-checkbox',
    checkboxes: 'form-checkbox',
    dropdown: 'form-dropdown',
    multiselect: 'form-dropdown',
    radio: 'form-radio',
    date: 'form-datepicker',
    datetime: 'form-datepicker',
    hidden: 'form-input',
    file: 'form-upload',
    multifile: 'form-upload',
  },
  fieldDefaults: {
    section_title: null,
    singleline: null,
    multiline: null,
    email: null,
    number: null,
    url: null,
    checkbox: false,
    checkboxes: [],
    dropdown: null,
    multiselect: [],
    radio: null,
    date: null,
    datetime: null,
    hidden: null,
    file: null,
    multifile: null,
  },
  formatter: {
    dateToString: (date) =>
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      date.getDate().toString().padStart(2, '0'),
  },
}
